import React from 'react';
import times from 'lodash/times';
import { ModalHeader } from '../../../../../../CommonComponents/OPL/Modal/ModalHeader';
import { Shimmer } from '../../../../../../CommonComponents/OPL/Shimmer/Shimmer';
import { ModalBody } from '../../../../../../CommonComponents/OPL/Modal/ModalBody';

import { Modal } from '../../../../../../CommonComponents/OPL/Modal/Modal';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';

export const AccountFormLoading = () => {
  return (
    <Modal isOpen>
      <ModalHeader>
        <Shimmer width={150} height={32} />
      </ModalHeader>

      <ModalBody>
        <Box display="flex" flexDirection="column" css="gap: 16px">
          {times(5).map((key, index) => (
            <Box key={key}>
              <Shimmer height={16} width={index % 2 ? 150 : 80} />
              <Shimmer height={37} mt={4} />
            </Box>
          ))}
        </Box>
      </ModalBody>
    </Modal>
  );
};
